import {Divider, Layout, message, Button, Row, Col,} from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { sendHttpPostRequest } from '../../api/http-request'
import Cookies from 'js-cookie'
import exerciseStyles from './exercise.module.less'
import './exercise.css'
import ExerciseCard from '../exercise/exercise-card'
import { checkIsTeacher } from '../../component/modal/teacher-authenticate/teacher-authenticate'


export interface Props {}
export interface Props2 {}

interface exerciseInfo {
  id: number
  title: string
  remarks: string
  type: number
  type_name: string
  difficulty: number
  difficulty_str: string
  score: number
  default_code: string
  steps: string
  preset_code: string
  language: number
  language_str: string
  judgement_code: string
  reference_answer: string
  answer_parse: string
  options: any
  options_answer: any
  datasets: any
  images: any
  source_page: number
  source_key: number
}

export const ExercisePreview: React.FC<Props> = (props) => {
  const exerciseId = parseInt(window.location.search.split('=')[1]) // 习题的ID
  const [exercise, setExercise] = useState(null as unknown as exerciseInfo) // 习题对象
  const isTeacher = useRef(false) // 是否为教师

  const queryExerciseCallback = (response) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
      // window.location.href = '/oam_login?next=oam_exercise_list';
    } else if (response.code == 0) {
      // 成功
      console.log(response.exercise_info)
      setExercise(response.exercise_info)
    } else if (response.code == -501) {
      // 权限不足
      // document.getElementById("show-login-modal")!.click();
      // window.location.href = '/oam_login?next=oam_exercise_list';
    } else {
      message.error(response.message)
    }
  }


  const refresh_table_tds = ()=>{
    setTimeout(function(){
      const table_tds = document.getElementsByTagName("td") //以下代码设置页面表格内容属性
      //console.log(table_tds)
      for(let i=0; i < table_tds.length;  i++){
          try{
            console.log(table_tds[i].innerText)
            table_tds[i].setAttribute('title', table_tds[i].innerText);
          }catch(error1){
            console.log(error1)
          }
        }

        const table_ths = document.getElementsByTagName("th") //以下代码设置页面表格内容属性
        //console.log(table_tds)
        for(let j=0; j < table_ths.length;  j++){
            try{
              //console.log(table_tds[i].innerText)
              table_ths[j].setAttribute('title', table_ths[j].innerText);
            }catch(error2){
              console.log(error2)
            }
          }
    }, 1000); //单位是毫秒

  }


  const add_link_target = ()=>{
    setTimeout(function(){
      const a_links = document.getElementsByTagName("a") //链接改为新弹出窗口效果
      for(let i=0; i < a_links.length;  i++){
          try{
            let href_ = a_links[i].getAttribute("href") as any
            if ( href_.indexOf('http') >= 0){
              a_links[i].setAttribute('target', '_blank');
            }
            
          }catch(error1){
            console.log(error1)
          }
        }
    }, 1000); //单位是毫秒

  }


  useEffect(() => {

    window.onload = function(){
      try{
        refresh_table_tds()
        add_link_target()
      }catch(error){
        console.log(error)
      }
    } 
    
    if (checkIsTeacher()) {
      isTeacher.current = true
    }
    queryExerciseInfo()
  }, [])

  // 查询习题详情
  const queryExerciseInfo = () => {
    sendHttpPostRequest(
      'exercise/api/query_exercise_by_id/',
      {
        exercise_id: exerciseId,
        sessionid: Cookies.get('sessionid'),
        source_page: 1, // 习题模块1
        source_key: 3, // 教师做题3，学生做题4
      },
      queryExerciseCallback
    )
  }

  return (
    <Layout style={{ minHeight: '100vh', backgroundColor: '#f9f9f9' }}>
      <div
        className={exerciseStyles.exercisePreview}
        style={{
          paddingTop: 20,
          width: 1000,
          marginTop: 30,
          backgroundColor: '#fff',
        }}
      >
        <Row align="middle">
          <Col
            span={12}
            style={{ textAlign: 'left', marginBottom: 10, width: '100%' }}
          >
            <div
              style={{
                marginLeft: 40,
                fontWeight: 600,
                fontSize: 18,
                color: '#333333',
              }}
            >
              {' '}
              题目详情{' '}
            </div>
          </Col>
          <Col
            span={12}
            style={{ textAlign: 'right', marginBottom: 10, width: '100%' }}
          >
            <Button
              style={{ marginRight: 40, color: '#333333' }}
              onClick={() => {
                window.close()//.location.href = '/exercise'
              }}
              type="link"
            >
              {' '}
              {'返回 >'}{' '}
            </Button>
          </Col>
        </Row>
        <Divider style={{ marginTop: 0 }} />

        <div style={{ marginLeft: 40, marginRight: 40, padding: 10 }}>
          <ExerciseCard
            exercise={exercise}
            renderType="white"
            teacherOnly={true}
            editorMode={true}
            showAnser={false}
            showClean={true}
          />
        </div>
      </div>
    </Layout>
  )
}

export default ExercisePreview
